import React, { useState, useContext, useEffect } from "react";
import clsx from "clsx";
import moment from "moment";
import {
  makeStyles,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  MenuItem,
  IconButton,
  Menu,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";

import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import CachedIcon from "@material-ui/icons/Cached";

import MainListItems from "./MainListItems";
import NotificationsPopOver from "../components/NotificationsPopOver";
import UserModal from "../components/UserModal";
import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import { i18n } from "../translate/i18n";
import toastError from "../errors/toastError";
import AnnouncementsPopover from "../components/AnnouncementsPopover";

import logo from "../assets/novoLogo.png";
import logoWhite from "../assets/logoLoginWhite.png";
import { socketConnection } from "../services/socket";
import ChatPopover from "../pages/Chat/ChatPopover";

//import { useDate } from "../hooks/useDate";

import ColorModeContext from "../layout/themeContext";
import { AccountCircle, AddAlert, CloseOutlined, MenuOpen } from "@material-ui/icons";

import { Alert, AlertTitle } from "@material-ui/lab";
import CloseIcon from "@material-ui/icons/Close";
import useCompanies from "../hooks/useCompanies";

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
    [theme.breakpoints.down("sm")]: {
      // height: "calc(100vh - 56px)",
      height: "calc(100vh)",
    },
    backgroundColor: theme.palette.fancyBackground,
    '& .MuiButton-outlinedPrimary': {
      color: theme.mode === 'light' ? '#00BFFF' : '#FFF',
      border: theme.mode === 'light' ? '1px solid rgba(0 124 102)' : '1px solid rgba(255, 255, 255, 0.5)',
    },
    '& .MuiTab-textColorPrimary.Mui-selected': {
      color: theme.mode === 'light' ? '#00BFFF' : '#FFF',
    }
  },
  avatar: {
    width: "100%",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    color: theme.palette.dark.main,
    background: theme.palette.barraSuperior,
    minHeight: "58px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 6px",
    minHeight: "44px",
    [theme.breakpoints.down("sm")]: {
      height: "44px",
      justifyContent: "flex-start", // Centraliza horizontalmente
    }
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 2,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    // width: `calc(100% - ${drawerWidth}px)`,
    width: "100%",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  menuButton: {
    marginRight: 21,
  }, 
  title: {
    flexGrow: 1,
    fontSize: 14,
    color: "white",
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    },
    ...theme.scrollbarStylesSoft
  },
  drawerPaperClose: {
    overflowX: "hidden",
    //paddingLeft: 10,    
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: 88,
    [theme.breakpoints.up("sm")]: {
      width: 88,
    },
    [theme.breakpoints.down("sm")]: {
      width: 88
    }
  },
  appBarSpacer: {
    minHeight: "58px",
  },
  content: {
    flex: 1,
    overflow: "auto",
    // 👇 ESTILO DA SCROLLBAR PERSONALIZADA (IGUAL AO MENU)
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.grey[500],
      borderRadius: "4px",
      border: "2px solid transparent", // Para suavizar bordas (opcional)
      backgroundClip: "padding-box",
    },
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column"
  },
  containerWithScroll: {
    listStyle: "none",
    margin: "54px 0 0", // mantém o espaçamento superior de 54px
    padding: "8px 0",
    position: "relative",
    height: "calc(100vh - 54px)", // altura ajustada para respeitar o espaço do menu superior
    [theme.breakpoints.down("sm")]: {
      margin: "0px 0 0", // remove o espaçamento em telas pequenas
      height: "100%", // ocupa toda a altura disponível
    },
  },   
  NotificationsPopOver: {
    // color: theme.barraSuperior.secondary.main,
  },
  logo: {
    width: "60%",
    height: "auto",
    maxWidth: 200,
    [theme.breakpoints.down("sm")]: {
      width: "90%", // Aumenta o tamanho em mobile      
      maxWidth: 180,
      height: "auto",
      marginTop: 10,
    },
    transition: "width 0.3s ease",
  },
  mobileToolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "& > *": {
      flexShrink: 0,
    },
  },
  menuButtonHidden: {
    [theme.breakpoints.up("sm")]: {
      display: "none", // Esconde somente quando o Drawer está aberto em telas maiores
    },
  },
  hideOnDesktop: {
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  hideOnMobile: {
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
}));

const LoggedInLayout = ({ children, themeToggle }) => {
  const classes = useStyles();
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const { handleLogout, loading } = useContext(AuthContext);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerVariant, setDrawerVariant] = useState("permanent");
  // const [dueDate, setDueDate] = useState("");
  const { user } = useContext(AuthContext);

  const theme = useTheme();
  const { colorMode } = useContext(ColorModeContext);
  const smallerThenSm = useMediaQuery(theme.breakpoints.down("sm"));

  const [volume, setVolume] = useState(localStorage.getItem("volume") || 1);

  const isDarkMode = theme.palette.type === 'dark';
  const logoImagem = isDarkMode ? logo : logoWhite;
  //const logoImagem = logo;

  const [showLicenseBanner, setShowLicenseBanner] = useState(true);
  const [companyDueDate, setCompanyDueDate] = useState(null);
  const { finding } = useCompanies();

  const shouldShowLicenseBanner = () => {
    // 1. Verifica se temos dados da empresa
    if (!companyDueDate) return false;

    // 2. Verifica se está na janela de aviso (vence em < 7 dias ou vencida)
    const today = moment();
    const daysUntilExpiry = companyDueDate.diff(today, "days");
    const isInWarningPeriod = daysUntilExpiry < 7;

    if (!isInWarningPeriod) return false;

    // 3. Verifica se foi fechado recentemente (menos de 24h)
    const closedAt = localStorage.getItem("licenseBannerClosedAt");
    if (closedAt) {
      const hoursPassed = (Date.now() - parseInt(closedAt)) / (1000 * 60 * 60);
      if (hoursPassed < 24) {
        return false;
      }
    }

    return true;
  };

  useEffect(() => {
    const loadCompanyDueDate = async () => {
      if (!user?.companyId) return;

      try {
        const company = await finding(user.companyId);
        setCompanyDueDate(company.dueDate ? moment(company.dueDate) : null);
      } catch (err) {
        console.error("Erro ao carregar dados da empresa", err);
      }
    }; 
    loadCompanyDueDate();   
  }, [user?.companyId]); // Executa quando o usuário for carregado

  useEffect(() => {
    const isVisible = shouldShowLicenseBanner();
    setShowLicenseBanner(isVisible);
  }, [companyDueDate]); // companyDueDate é a única dependência real aqui

  useEffect(() => {
    if (!smallerThenSm) {
      setDrawerOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDrawerVariant(smallerThenSm ? "temporary" : "permanent");
  }, [smallerThenSm]);

  useEffect(() => {
    const companyId = localStorage.getItem("companyId");
    const userId = localStorage.getItem("userId");

    const socket = socketConnection({ companyId });

    socket.on(`company-${companyId}-auth`, (data) => {
      if (data.user.id === +userId) {
        toastError("Sua conta foi acessada em outro computador.");
        setTimeout(() => {
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    });

    socket.emit("userStatus");
    const interval = setInterval(() => {
      socket.emit("userStatus");
    }, 1000 * 60 * 5);

    return () => {
      socket.disconnect();
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Fecha a Faixa por 24 horas
  const handleCloseBanner = () => { 
    setShowLicenseBanner(false);
    localStorage.setItem("licenseBannerClosedAt", Date.now().toString());
  }

  useEffect(() => {
    let autoCloseTimer;
    if (smallerThenSm && showLicenseBanner) {
      autoCloseTimer = setTimeout(() => {
        handleCloseBanner();
        setShowLicenseBanner(false); // opcional, mas consistente
      }, 15000); // Fecha após 15 segundos
    }
    return () => {
      if (autoCloseTimer) clearTimeout(autoCloseTimer);
    };
  }, [smallerThenSm, showLicenseBanner]);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  const handleOpenUserModal = () => {
    setUserModalOpen(true);
    handleCloseMenu();
  };

  const handleClickLogout = () => {
    handleCloseMenu();
    handleLogout();
  };

  const drawerClose = () => {
    if (document.body.offsetWidth < 600) {
      setDrawerOpen(false);
    }
  };

  const handleRefreshPage = () => {
    window.location.reload(false);
  }

  const handleMenuItemClick = () => {
    const { innerWidth: width } = window;
    if (width <= 600) {
      setDrawerOpen(false);
    }
  };

  const toggleColorMode = () => {
    colorMode.toggleColorMode();
  }

  if (loading) {
    return <BackdropLoading />;
  }

  return (
    <div className={classes.root}>
      <UserModal open={userModalOpen} onClose={() => setUserModalOpen(false)}userId={user?.id} />
      
      {showLicenseBanner && (
        <Alert
          severity={companyDueDate.isBefore(moment()) ? "error" : "warning"}
          variant="filled"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            borderRadius: 0,
            zIndex: 1300,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            whiteSpace: "nowrap",     // ← TUDO EM UMA LINHA
            overflow: "hidden",       // ← ESCONDE EXCESSO
            textOverflow: "ellipsis", // ← ADICIONA "..." SE NECESSÁRIO
            padding: "0 16px",        // ← AJUSTA ESPAÇAMENTO LATERAL
          }}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleCloseBanner}
              style={{ flexShrink: 0 }} // ← IMPEDI QUE O BOTÃO ENCOLHA
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              lineHeight: 1.4,
              display: "block", // necessário para o text-overflow funcionar corretamente
            }}
          >
            {smallerThenSm ? (
              // Versão compacta para mobile
              companyDueDate.isBefore(moment()) ? (
                <>
                  <strong>Licença expirada!</strong> Venceu em {companyDueDate.format("DD/MM")}.
                </>
              ) : (
                <>
                  <strong>Vence em {companyDueDate.format("DD/MM")}!</strong> Renove para evitar bloqueio.
                </>
              )
            ) : (
              // Versão completa para desktop
              <>
                {companyDueDate.isBefore(moment())
                  ? "Licença Expirada! Sua assinatura venceu em "
                  : "Licença Vence em Breve! Sua assinatura vence em "}
                <strong>{companyDueDate.format("DD/MM/YYYY")}</strong>.
                {companyDueDate.isBefore(moment())
                  ? " Renove agora para evitar interrupções."
                  : " Renove antecipadamente para garantir o acesso contínuo."}
              </>
            )}
          </span>
        </Alert>
      )}

      <AppBar
        position="fixed"
        className={clsx(classes.appBar, drawerOpen && classes.appBarShift)}
        color="primary"
        style={{
          top: showLicenseBanner ? 32 : 0, // ← EMPURRA O APPBAR PARA BAIXO SE A FAIXA ESTIVER VISÍVEL
        }}
      >
        <Toolbar variant="dense" className={classes.toolbar}>
          {/* Botão do Drawer (aparece em todas as resoluções) */}
          <IconButton
            edge="start"
            aria-label={drawerOpen ? "close drawer" : "open drawer"}
            onClick={() => setDrawerOpen(!drawerOpen)}
            className={classes.menuButton}
            color="inherit"
          >
            {drawerOpen ? (
              <MenuOpen style={{ color: "white" }} />
            ) : (
              <MenuIcon style={{ color: "white" }} />
            )}
          </IconButton>

          {/* Logo centralizada */}
          <img
            src={logoImagem}
            className={classes.logo}
            alt="logo"
            style={{
              maxHeight: 40,
              objectFit: "contain",
            }}
          />

          {/* Ícones do lado direito */}
          <div className={classes.rightSection}>
            <IconButton
              onClick={handleRefreshPage}
              aria-label={i18n.t("mainDrawer.appBar.refresh")}
              color="inherit"              
            >
              <CachedIcon style={{ color: "white" }} />
            </IconButton>
            
            <AnnouncementsPopover className={classes.hideOnMobile} />
            
            {user.id && <NotificationsPopOver volume={volume} />}
            
            <ChatPopover className={classes.hideOnMobile} />
            
            {/* <div>
              <IconButton
                className={classes.hideOnMobile}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <AccountCircle style={{ color: "white" }} />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={menuOpen}
                onClose={handleCloseMenu}
              >
                <MenuItem onClick={handleOpenUserModal}>
                  {i18n.t("mainDrawer.appBar.user.profile")}
                </MenuItem>
              </Menu>
            </div> */}
          </div>
        </Toolbar>
      </AppBar>

      <Drawer
        variant={drawerVariant}
        className={drawerOpen ? classes.drawerPaper : classes.drawerPaperClose}
        classes={{
          paper: clsx(
            classes.drawerPaper,
            !drawerOpen && classes.drawerPaperClose
          ),
        }}
        open={drawerOpen}
        style={{
          marginTop: showLicenseBanner ? 32 : 0, // ← EMPURRA O DRAWER PARA BAIXO
        }}
      >        
        <div className={classes.hideOnDesktop}>
          <div className={classes.toolbarIcon}>
            <div style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}>
              {/* <img src={logoImagem} className={classes.logo} alt="logo" /> */}
            </div>
            <IconButton 
              onClick={() => setDrawerOpen(!drawerOpen)}            
            >
              <ChevronLeftIcon />
            </IconButton>
          </div>
        </div>

        {/* <Divider /> */}
        <List className={classes.containerWithScroll}>
          <MainListItems drawerClose={drawerClose} collapsed={!drawerOpen} volume={volume} setVolume={setVolume} />
        </List>
        {/* <Divider /> */}
      </Drawer>

      <main className={classes.content}>
        <div className={classes.appBarSpacer} 
          style={{
            minHeight: showLicenseBanner ? 122 : 58, // ← AJUSTA ESPAÇAMENTO ACIMA DO CONTEÚDO
          }}        
        />
        {children ? children : null}
      </main>
    </div>
  );
};

export default LoggedInLayout;